
    <ng-container *ngIf="parent.disableScroll; else enableScroll">
        <ng-container *ngTemplateOutlet="optionsTemplate"></ng-container>
    </ng-container>

    <ng-template #enableScroll>
        <scrolldiv style="flex: 1 1 0%; overflow: hidden; width: 100%; height: 100%"
                   [scrollerSize]="20"
                   [navigatorSize]="14"
                   [scrollVerticalIndent]="0"
                   cls="lightScroll">
            <ng-container *ngTemplateOutlet="optionsTemplate"> </ng-container>
        </scrolldiv>
    </ng-template>


<ng-template #optionsTemplate>
    <div class="close-cnt cnt-row">
        <div class="filler"></div>
        <div class="upgrade-btn-close"
             (click)="onClose()"
             data-testid="closeBtn">
        </div>
        <div [width]="10"></div>
    </div>

    <div [height]="50"></div>

    <div class="cnt-column-centered card-container-wrap">
        <div class="cnt-column-centered card-container">


            <span class="header-text-font-brixx" style="font-weight: 600; font-size: 52px" i18n>{{ 'SCALE_UP_YOUR_BUSINESS' | translate }}</span>
            <span class="header-text-font-brixx" style="font-weight: 400; font-size: 20px; margin-top: 15px; color: #424A5D" i18n>
                {{ 'ENAHNCE_YOUR_SUBSCRIPTION_TO' | translate }}
            </span>

            <div [height]="45"></div>

            <div class="cnt-row" style="justify-content: center">

                <div class="new-product-card-brixx white-background">

                    <div class="cnt-column" style="padding: 25px 50px 20px 50px;">
                        <div [ngClass]="{
                                'light-blue-rectangle' : !isBusinessDoctors,
                                'light-blue-rectangle-business-doctors' : isBusinessDoctors
                             }">
                            <span style="font-size: 14px; font-weight: 600">{{ 'CURRENT_SUBSCRIPTION' | translate }}</span>
                        </div>
                    </div>

                    <div class="cnt-column" style="padding: 0 50px 0 50px;">
                        <div style="display: flex; flex-direction: row; align-items: center; height: 60px">
                            <span style="font-size: 48px; padding-right: 12px; font-weight:700" data-testid="SubscriptionPrice">{{ currentCurSymbol }}{{ formattedInitialPrice() }}</span>
                            <span style="font-size: 18px; padding-right: 5px;">
                                {{ 'SLASH_MONTH_BILLED' | translate }}
                                <span [translate]="initialSubscriptionType === 'Monthly' ? 'MONTHLY' : 'ANNUALLY'"></span>
                                {{ 'AT' | translate }}
                            </span>
                            <span style="font-size: 18px; font-weight: 600;" data-testid="SubscriptionTotalPrice">{{ currentCurSymbol }} {{ initialBilledPrice}}</span>
                        </div>

                        <div [height]="20"></div>

                        <div style="display: flex; align-items: center">
                            <div class="success-logo-container" style="margin-right: 10px;"></div>
                            <span style="font-size: 18px;">{{ 'ALL_FEATURES' | translate }}</span>
                        </div>

                        <div [height]="15"></div>

                        <div style="display: flex; align-items: center">
                            <div class="success-logo-container" style="margin-right: 10px;"></div>
                            <span style="font-size: 18px;">{{initialPlanCount}} <span [translate]="initialPlanCount === 1 ? 'PLAN' : 'plans'"></span></span>
                        </div>

                        <div [height]="15"></div>

                        <div class="cnt-row-centered" style="justify-content: space-between;">
                            <div style="display: flex; align-items: center;">
                                <div class="success-logo-container" style="margin-right: 10px;"></div>
                                <span style="font-size: 18px;">{{ 'CUSTOMER_SUPPORT' | translate }}</span>
                            </div>
                        </div>

                    </div>

                    <div [height]="75"></div>

                    <div class="cnt-column-centered">
                        <div class="current-plan-btn">
                            <span style="font-size: 18px; font-weight: 600; color: #c0c3c8" i18n>{{ 'CURRENT_PLAN' | translate }}</span>
                        </div>
                    </div>

                </div>

                <div class="new-product-card-brixx white-background">
                    <upgrade [isBuyPlanSlot]="true"
                             [licenseData]="licenseData">
                             <!--[initialPlanCount]="initialPlanCount"-->
                    </upgrade>
                </div>

            </div>


        </div>
    </div>
</ng-template>